module.exports = __webpack_public_path__ + "img/stick_activites_parcours_orientation.39b527a2.svg";